import {
  ProductClass,
} from '../../graphQL/types/shared';
import {
  hsColorsMap,
  ICPYDatum,
  ILoadable,
  IPYDatum,
  sitcColorMap,
} from '../../Utils';
import {
  NodeSizing,
} from '../../viz/Utils';
import {
  ILayoutData,
} from '../fetchedData/layoutData';
import {
  IMetadatum,
} from '../fetchedData/productMetadata';
import assignActive from './assignActiveStatusAndSize';
import assignSection from './assignSectionAndColorToNode';
import getActive from './getActiveStatusGetter';
import {
  IHasNoError,
  IInputFromURLRouting,
  ISuccessfulMergeAction,
} from './getReducer';
import getSize from './getSize';
import merge from './mergeWithData';
import {
  updateMergedData,
} from './reducer';
import {
  RelatedNodesMap,
} from './Utils';

export interface IComputationInput {
  chartContainerWidth: number | undefined;
  chartContainerHeight: number | undefined;
  data: ILoadable<ICPYDatum[]>;
  metadata: ILoadable<Record<string, IMetadatum>>;
  layoutData: ILoadable<ILayoutData>;
  relatedNodesMap: ILoadable<RelatedNodesMap>;
  availableYears: ILoadable<number[]>;
  levelMapping: ILoadable<Record<string, number>>;
  worldTrade: ILoadable<IPYDatum[]>;
  productClass: ProductClass;
  nodeSizing: NodeSizing;
  deselectedCategories: number[];
  rcaThreshold: number;
}

interface IComputeInput {
  // Info that's actually used in the computation:
  computationInput: IComputationInput;

  // Pass through to hash function:
  queueNumber: number;
  inputFromURLRouting: IInputFromURLRouting;
}
const compute = (
    {computationInput, queueNumber, inputFromURLRouting}: IComputeInput,
  ): ISuccessfulMergeAction => {

  const {
    chartContainerWidth, chartContainerHeight, nodeSizing, deselectedCategories, rcaThreshold,
    data, metadata, levelMapping, relatedNodesMap,
    layoutData, availableYears, worldTrade, productClass,
  } = computationInput;
  const {
    country, year, queryLevel
  } = inputFromURLRouting;
  const size = getSize(chartContainerWidth, chartContainerHeight);
  const colorMap = (productClass === ProductClass.HS) ? hsColorsMap : sitcColorMap;

  const sectionAssigned = assignSection(size, layoutData, levelMapping, metadata, colorMap, productClass);
  const merged = merge(sectionAssigned, data, worldTrade);
  const isActive = getActive(deselectedCategories, rcaThreshold);
  const value = assignActive(
    relatedNodesMap, availableYears, merged, isActive, nodeSizing, size, productClass, year,
  );
  const mergedData: IHasNoError = {
    hasError: false, value,
  };
  const computationResult = {
    mergedData,
    hashInput: {
      deselectedCategories, rcaThreshold,
      chartContainerHeight, chartContainerWidth,
      country, queryLevel, year, productClass, nodeSizing,
    },
    queueNumber,
  };
  const result: ISuccessfulMergeAction = updateMergedData(computationResult);
  return result;
};

export default compute;
